var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"smoo-role-icon",attrs:{"src":require('@/assets/tag/' + _vm.$attrs.type + '.png'),"alt":"role icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }